import React, { useState, useEffect, useMemo, useRef } from "react";
import { Row, Col, Button } from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import TextInput from "../../../custom/components/Text-Input/TextInput.js";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput.js";
import CustomForm from "../../../custom/Forms/CustomForm.js";
import SelectInput from "../../../custom/components/Select-Input/SelectInput.js";
import {
  dropdownData,
  getRecords,
  saveRecords,
  uploadExelFile,
} from "../../../services/api.service.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useCreateForm from "../../../custom/Utils/UseCreateFormUtils.js";
import { createPageData } from "./BOMFile.js";
import { basicFormData } from "./BOMFile.js";
import Asterisks from "../../../custom/components/Asterisks/Asterisks.js";
import TextAreaInput from "../../../custom/components/TextArea-Input/TextAreaInput.js";
import NumberInput from "../../../custom/components/Number-Input/NumberInput.js";
import { showConfirmationToast } from "../../../services/toaster/ConfirmToaster";
import PopupManager from "../../../services/popup/PopupManager.js";
import "../../../Style/popup.css";
import ModernPopup from "../../../services/popup/Popup.js";
const BOMCreate = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  } = createPageData();
  const [loadingData, setLoadingData] = useState(false);
  const initialPayload = useMemo(() => payload, []);

  const [selectedBuyOptions, setSelectedBuyOptions] = useState([]);
  const [buyItemList, setBuyItemList] = useState([]);
  const [buyItemData, setBuyItemData] = useState([]);
  const [selectedMakeOptions, setSelectedMakeOptions] = useState([]);
  const [makeItemList, setMakeItemList] = useState([]);
  const [makeItemData, setMakeItemData] = useState([]);
  const [uomItemList, setUomItemList] = useState([]);
  const [makeDesc, setMakeDesc] = useState("");
  const isToastOpenRef = useRef(false);

  const {
    formData,
    setFormData,
    onInputChange,
    formErrors,
    setFormErrors,
    selectedDropOption,
    setSelectedDropOption,
    selectedDropdownOptions,
    handleSelectChange,
  } = useCreateForm(
    getEndpoint,
    id,
    initialPayload,
    basicFormData(),
    validationType
  );

  const [rows, setRows] = useState([]);
  const [errors, setErrors] = useState({});
  const [formsErrors, setFormsErrors] = useState({});

  const [showPopup, setShowPopup] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [itemIndexToRemove, setItemIndexToRemove] = useState(null);
  const [popupData, setPopupData] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });

  useEffect(() => {
    if (id && formData.inputData?.bomMakeItem) {
      const updatedRows = formData.inputData.bomMakeItem.map((item) => {
        const uom = item.buyItem?.uom?.uom_name || "N/A";
        const description = item.buyItem?.description || "No description";
        return {
          ...item,
          uom,
          description,
        };
      });
      setRows(updatedRows);
      setMakeDesc(formData.inputData?.description);
    } else {
      console.log("id is not available or bomMakeItem is missing");
      setRows(formData?.inputData);
    }
  }, [id, formData.inputData]);

  const handleSubmit = async (e) => {
    setLoadingData(true);

    if (!validateForm() | !validateForms()) {
      setLoadingData(false);

      return;
    }

    try {
      e.preventDefault();

      const isCreating = !id;
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));

      const mappedRows = rows.map((row) => ({
        ...row,
        created_by: isCreating ? userDetails.id : row.created_by,
        updated_by: userDetails.id,
      }));

      const payload = {
        id,
        modelName: "bom_masters",
        inputData: mappedRows.length === 1 ? mappedRows[0] : mappedRows,
      };
      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      if (responseData && responseData.code == 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData?.message ||
            `Error while ${id ? "updating" : "saving"} ${headerName}!`
        );
      }
    } catch (error) {
      console.error("err", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  const setSelectedOption = (options, value, setSelected) => {
    const matchedOption = options.find((option) => option.value == value);
    setSelected(
      matchedOption
        ? { label: matchedOption.label, value: matchedOption.value }
        : null
    );
  };
  useEffect(() => {
    if (formData?.inputData?.bomMakeItem?.length > 0 && makeItemList.length) {
      setSelectedOption(
        makeItemList[0]?.options,
        String(formData.inputData?.bomMakeItem[0]?.make_item_id),
        setSelectedMakeOptions
      );
    }
  }, [formData?.inputData, makeItemList]);

  useEffect(() => {
    if (buyItemList.length && formData.inputData?.bomMakeItem?.length) {
      formData.inputData.bomMakeItem.forEach((item, index) => {
        const buyItem = buyItemList.find(
          (buyItem) => buyItem.label === item.buy_item_name
        );

        if (buyItem) {
          setSelectedOption(
            buyItem.options,
            String(item.buy_item_id),
            (option) => {
              setSelectedBuyOptions((prev) => {
                const updatedOptions = [...prev];
                updatedOptions[index] = option;
                return updatedOptions;
              });
            }
          );
        }
      });
    }
  }, [buyItemList, formData.inputData]);

  useEffect(() => {
    const getIMaketemOptions = async () => {
      const payload = {
        modelName: "item_masters",
        whereCondition: {
          type: 1,
        },
      };
      try {
        const responseData = await getRecords(payload, "/listItem");
        if (responseData?.data.length > 0) {
          const bomPayload = {
            modelName: "bom_masters",
            whereCondition: {
              is_active: true,
            },
          };
          const bomResponseData = await getRecords(bomPayload, "/getRecords");

          let uniqueRecords = responseData?.data;
          if (bomResponseData?.data.length > 0) {
            const array1 = responseData.data;
            const array2 = bomResponseData.data;
            uniqueRecords = id
              ? responseData.data
              : getUniqueRecords(array1, array2);
          }
          const dropdownResponseData = await dropdownData(
            uniqueRecords,
            "item_code",
            "make_item_id",
            false
          );
          setMakeItemData(uniqueRecords);
          setMakeItemList(dropdownResponseData);
        }
      } catch (error) {
        console.error("Error fetching category options:", error);
      }
    };

    const getUniqueRecords = (array1, array2) => {
      // Merge both arrays with a normalized `id` field to compare
      const mergedArray = [
        ...array1.map((item) => ({ ...item, id: item.id })),
        ...array2.map((item) => ({ ...item, id: item.make_item_id })),
      ];

      // Create a count map to track occurrences of each id/item_id
      const countMap = mergedArray.reduce((acc, item) => {
        acc[item.id] = (acc[item.id] || 0) + 1;
        return acc;
      }, {});

      // Filter out records where the id/item_id appears more than once (only keep unique ones)
      const uniqueRecords = mergedArray.filter(
        (item) => countMap[item.id] === 1
      );

      // Sort the unique records by id/item_id
      uniqueRecords.sort((a, b) => a.id - b.id);

      return uniqueRecords;
    };

    const getItemOptions = async () => {
      const payload = {
        modelName: "item_masters",
        whereCondition: {
          type: 2,
        },
      };
      try {
        const responseData = await getRecords(payload, "/listItem");
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "item_code",
          "buy_item_id",
          false
        );
        setBuyItemData(responseData.data);
        setBuyItemList(dropdownResponseData);
      } catch (error) {
        console.error("Error fetching category options:", error);
      }
    };
    const getUomOptions = async () => {
      const payload = {
        modelName: "uom_masters",
      };
      try {
        const responseData = await getRecords(payload, "/listUom");

        setUomItemList(responseData.data);
      } catch (error) {
        console.error("Error fetching category options:", error);
      }
    };
    getItemOptions();
    getUomOptions();
    getIMaketemOptions();
  }, []);
  useEffect(() => {
    if (selectedDropdownOptions.length) {
      setSelectedOption(
        selectedDropdownOptions[0]?.options,
        formData.inputData?.parent_id,
        setSelectedDropOption
      );
    }
  }, [formData.inputData?.parent_id, selectedDropdownOptions]);

  const handleSelectBuyItem = (selectedOption, index) => {
    const updatedRows = [...rows];

    const selectedItem = buyItemData.find(
      (item) => item.id === selectedOption?.value
    );

    const selectedUOM = uomItemList.find(
      (uom) => uom.id === selectedItem?.uom_id
    );

    updatedRows[index].buy_item_id = selectedOption ? selectedOption.value : "";
    updatedRows[index].description = selectedItem
      ? selectedItem.description
      : "";
    updatedRows[index].uom = selectedUOM ? selectedUOM.uom_name : "";

    setSelectedBuyOptions((prev) => {
      const updatedOptions = [...prev];
      updatedOptions[index] = selectedOption;
      return updatedOptions;
    });

    let validationErrors = { ...errors };
    delete validationErrors[`buyItem-${index}`];
    delete validationErrors[`description-${index}`];
    delete validationErrors[`uom-${index}`];

    setErrors(validationErrors);

    setRows(updatedRows);
  };

  const handleSelectMakeItem = (selectedOption, index) => {
    setRows((prevRows) =>
      prevRows.map((row) => ({
        ...row,
        make_item_id: selectedOption ? selectedOption.value : "",
      }))
    );

    const selectedItem = makeItemData.find(
      (item) => item.id === selectedOption?.value
    );

    setMakeDesc(selectedItem ? selectedItem.description : "");
    setSelectedMakeOptions(selectedOption);
    setFormsErrors((prevErrors) => ({
      ...prevErrors,
      make_item: selectedOption ? "" : prevErrors.make_item,
      description: "",
    }));
  };

  const handleAddRow = () => {
    const isAnyRowIncomplete = rows.some(
      (row) => !row.buy_item_id || row.qty_per_item === ""
    );

    if (isAnyRowIncomplete) {
      toast.error(
        "Please fill in all fields in the existing rows before adding a new row."
      );
      return;
    }

    setRows((prevRows) => [
      ...prevRows,
      {
        make_item_id: selectedMakeOptions?.value || "",
        buy_item_id: "",
        qty_per_item: "",
        is_active: true,
      },
    ]);
  };

  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const updatedRows = [...rows];

    updatedRows[index][name] = value;

    let validationErrors = { ...errors };

    if (name === "qty_per_item" && !value) {
      validationErrors[`qtyPerItem-${index}`] = "Quantity per BOM is required";
    } else if (name === "qty_per_item" && value <= 0) {
      validationErrors[`qtyPerItem-${index}`] = "Invalid quantity per BOM.";
    } else {
      delete validationErrors[`qtyPerItem-${index}`];
    }

    setErrors(validationErrors);

    setRows(updatedRows);
  };

  const getData = async (id) => {
    try {
      let payload = {
        ...initialPayload,
      };

      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);
      if (responseData.data && responseData.data.length > 0) {
        if (id) {
          setFormData({ inputData: responseData.data[0] });
        }
      }
      setLoadingData(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const selectedItems = rows.map((row) => row.buy_item_id);
  const validateForm = () => {
    let validationErrors = {};
    let isValid = true;

    rows.forEach((row, index) => {
      if (!selectedBuyOptions[index]) {
        validationErrors[`buyItem-${index}`] = "Buy item is required";
        isValid = false;
      }

      if (!row.description) {
        validationErrors[`description-${index}`] = "Description is required";
        isValid = false;
      }
      if (!row.qty_per_item || row.qty_per_item === "") {
        validationErrors[`qtyPerItem-${index}`] =
          "Quantity per BOM is required";
        isValid = false;
      } else if (isNaN(row.qty_per_item) || row.qty_per_item <= 0) {
        validationErrors[`qtyPerItem-${index}`] = "Invalid quantity per BOM.";
        isValid = false;
      }

      if (!row.uom) {
        validationErrors[`uom-${index}`] = "UOM is required";
        isValid = false;
      }
    });

    setErrors(validationErrors);
    return isValid;
  };

  const validateForms = () => {
    const errors = {};
    let isValid = true;

    if (!selectedMakeOptions || selectedMakeOptions.length === 0) {
      errors.make_item = "Make item code is required";
      isValid = false;
    }

    if (!makeDesc.trim()) {
      errors.description = "Description is required";
      isValid = false;
    }

    setFormsErrors(errors);

    return isValid;
  };

  // handle remove item
  const handleRemove = (index) => {
    if (id) {
      setPopupMessage("Are you sure you want to remove this item?");
      setShowConfirmation(true);
      setItemIndexToRemove(index);
    } else {
      const updatedDetails = rows.filter((_, i) => i !== index);
      setRows(updatedDetails);
    }
  };

  const handleConfirm = async () => {
    setShowConfirmation(false);
    const updatedRows = rows.map((row, i) =>
      i === itemIndexToRemove ? { ...row, is_active: false } : row
    );
    const payload = {
      id: id,
      modelName: "bom_masters",
      inputData: updatedRows,
    };

    await saveRecords(payload, updateEndpoint);
    await getData(id);

    setRows(updatedRows);
    const updatedRowsdata = rows.filter((_, i) => i !== itemIndexToRemove);
    setRows(updatedRowsdata);
    // Simulate an API call or logic to handle removal
    const success = true; // Change this to simulate error scenario

    if (success) {
      setPopupMessage("Item removed successfully!");
      setIsError(false);
    } else {
      setPopupMessage("Failed to remove the item. Please try again.");
      setIsError(true);
    }

    setShowPopup(true);
  };

  const handleRedirectToLogin = () => {
    setShowPopup(false);
  };

  const handleFileUpload = async (e) => {
    if (selectedMakeOptions && selectedMakeOptions?.value) {
      try {
        const file = e.target.files[0];

        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (fileExtension !== "xlsx" && fileExtension !== "xls") {
          throw new Error("Please select a valid Excel file.");
        }

        // setIsLoadingData(true);
        const userDetails =
          JSON.parse(localStorage.getItem("userDetails")) || {};
        const createdBy = userDetails.id || null;

        const res = await uploadExelFile(
          "uploads",
          file,
          `/importBomItems?createdBy=${createdBy}&make_item_id=${selectedMakeOptions?.value}`
        );

        // setIsLoadingData(false);
        if (res?.code != 0 && res?.message) {
          setPopupData({
            isOpen: true,
            message: res.message || "File imported successfully!",
            isError: false,
          });
          // Navigate after a short delay (e.g., 2 seconds)
          setTimeout(() => {
            navigate(navigatePage?.back);
          }, 2000); // Delay in milliseconds
        } else if (res?.code == 0) {
          setPopupData({
            isOpen: true,
            message: res?.message || "Error importing file. Please try again.",
            isError: true,
          });
        }
      } catch (error) {
        console.error("Upload error:", error);
        // setIsLoadingData(false);

        const errorMessage =
          error?.message ||
          error?.Error ||
          "An error occurred while importing. Please try again.";

        setPopupData({
          isOpen: true,
          message: errorMessage,
          isError: true,
        });
      }
    } else {
      toast.error("Please select make item first.");
    }

    setTimeout(() => {
      e.target.value = "";
    }, 0);
  };

  const closePopup = () => {
    setPopupData((prev) => ({ ...prev, isOpen: false }));
  };

  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <PopupManager
        showPopup={showPopup}
        setShowPopup={setShowPopup}
        showConfirmation={showConfirmation}
        setShowConfirmation={setShowConfirmation}
        popupMessage={popupMessage}
        isError={isError}
        onConfirm={handleConfirm}
        onRedirectToLogin={handleRedirectToLogin}
      />
      <ModernPopup
        isOpen={popupData.isOpen}
        onClose={closePopup}
        message={popupData.message}
        isError={popupData.isError}
      />

      <Row>
        <Col className="d-flex justify-content-end text-center">
          <Button
            color="success"
            className="waves-effect waves-light me-1"
            onClick={() => document.getElementById("fileInput").click()}
          >
            Import
          </Button>
          <input
            type="file"
            id="fileInput"
            style={{ display: "none" }}
            accept=".xlsx, .xls"
            onChange={(e) => handleFileUpload(e)}
          />
        </Col>
      </Row>
      <Row className="mt-1">
        <Col md="6" className="mt-3">
          <SelectInput
            label="Make Item Code"
            value={selectedMakeOptions}
            options={makeItemList?.map((item) => ({
              ...item,
              options: item.options.sort((a, b) => b.value - a.value),
            }))}
            onSelect={handleSelectMakeItem}
            placeholder="Select Make Item"
            parentClassName=""
            selectClassName=""
            labelClassName="form-label"
            parentStyle={{}}
            selectStyle={{}}
            labelStyle={{}}
            size={1}
            noDataMessage="data not found"
            maxMenuHeight={200}
            isClearable={false}
            customError={formsErrors.make_item}
            asterisk={true}
          />
        </Col>

        <Col md="6" className="mt-3">
          <TextInput
            label="Description"
            name="description"
            value={makeDesc}
            onChange={onInputChange}
            placeholder="Description"
            parentClassName=""
            inputClassName="form-control"
            labelClassName="form-label"
            parentStyle={{}}
            inputStyle={{}}
            labelStyle={{}}
            maxLength
            minLength
            readOnly={true}
            disabled={true}
            required={false}
            spellcheck={false}
            size
            pattern="[A-Za-z0-9]+"
            autocomplete={"off"}
            customError={formsErrors?.description}
            asterisk={true}
          />
        </Col>
      </Row>

      <div className="container">
        <div className="mt-4">
          <Col
            style={{
              marginLeft: "",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingBlock: "5px",
              gap: "1rem",
            }}
          >
            <div>
              <h6 className="h-6-heading m-0"> Buy Item Details</h6>
            </div>
            <Button
              color="primary"
              className="waves-effect waves-light me-1"
              onClick={handleAddRow}
              style={{ background: "#006eb9" }}
            >
              Add
            </Button>
          </Col>
          <div
            className="table"
            style={{
              overflowX: "auto",
              overflowY: "auto",
              maxHeight: "500px",
              width: "100%",
              scrollBehavior: "smooth",
              scrollbarWidth: "thin",
              msOverflowStyle: "none",
              zIndex: 0,
            }}
          >
            <table className="table table-hover">
              <thead
                style={{
                  backgroundColor: "#8AC1E8",
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#8AC1E8",
                  borderBottom: "1px solid black",
                  zIndex: 1,
                }}
              >
                <tr
                  style={{
                    borderBottom: "1px solid black",
                  }}
                >
                  <th>Sr. No</th>
                  <th>
                    Buy Item Code <Asterisks asterisk={true} />
                  </th>
                  <th>Buy Item Description</th>
                  <th>UOM</th>
                  <th>
                    Quantity per BOM <Asterisks asterisk={true} />
                  </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {rows?.map((row, index) => (
                  <tr
                    key={index}
                    style={{
                      borderBottom: "1px solid #cccccc",
                      verticalAlign: "middle",
                    }}
                  >
                    <td>{index + 1}</td>
                    <td>
                      <SelectInput
                        value={selectedBuyOptions[index]}
                        // options={buyItemList.map((optionGroup) => {
                        //   return {
                        //     ...optionGroup,
                        //     options: optionGroup.options.filter(
                        //       (option) => !selectedItems.includes(option.value)
                        //     ),
                        //   };
                        // })}
                        options={buyItemList.map((optionGroup) => ({
                          ...optionGroup,
                          options: optionGroup.options
                            .filter(
                              (option) => !selectedItems.includes(option.value)
                            )
                            ?.sort((a, b) => b.value - a.value),
                        }))}
                        onSelect={(option) =>
                          handleSelectBuyItem(option, index)
                        }
                        placeholder="Select an option"
                        noDataMessage="No options available"
                        labelStyle={{ display: "none" }}
                        customError={errors[`buyItem-${index}`]}
                      />
                    </td>
                    <td>
                      <TextInput
                        name={`description-${index}`}
                        value={row.description}
                        inputClassName="form-control"
                        labelClassName="form-label"
                        labelStyle={{ display: "none" }}
                        readOnly
                        autocomplete="off"
                      />
                    </td>
                    <td>
                      <TextInput
                        name={`uom-${index}`}
                        value={row.uom}
                        inputClassName="form-control"
                        labelClassName="form-label"
                        labelStyle={{ display: "none" }}
                        readOnly
                        autocomplete="off"
                      />
                    </td>

                    <td>
                      <div key={index} className="row">
                        <NumberInput
                          name="qty_per_item"
                          inputClassName="form-control"
                          labelClassName="form-label"
                          value={row.qty_per_item || ""}
                          onChange={(e) => handleChange(e, index)}
                          className="form-control"
                          placeholder="Quantity per BOM"
                          customError={errors[`qtyPerItem-${index}`]}
                          labelStyle={{ display: "none" }}
                        />
                      </div>
                    </td>
                    <td>
                      <div onClick={() => handleRemove(index)}>
                        <Link className="text-danger">
                          <i className="mdi mdi-trash-can font-size-20"></i>
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </CustomForm>
  );
};
export default BOMCreate;
